import * as React from 'react'
import { Field } from '@metrisk/react_metrisk-components'

const GBInputs: React.FunctionComponent<GBInputs.IProps> = (props) => {
  const { value, onChange } = props
  const [valid, setValid] = React.useState({ accountName: null, accountNo: null, sortCode: null })

  const handleAccountName = (input: string) => {
    const updatedValid = { ...valid, ...{ accountName: !!input } }
    const validBankDetails = Object.values(updatedValid).every(Boolean)
    setValid(updatedValid)
    onChange({ ...value, ...{ accountName: input, valid: validBankDetails } })
  }

  const handleAccountNo = (input: string) => {
    input = input.length <= 8 ? input : value.accountNo
    const validAccountNo = RegExp(/^(\d{8})$/).test(input)
    const updatedValid = { ...valid, ...{ accountNo: validAccountNo } }
    const validBankDetails = Object.values(updatedValid).every(Boolean)
    setValid(updatedValid)
    onChange({ ...value, ...{ accountNo: input, valid: validBankDetails } })
  }

  const handleSortCode = (input: string) => {
    // Format input to xx-xx-xx sort code format
    if (input) {
      const parts = input.match(/\w{1,2}/g)
      if (parts && parts.length <= 3) {
        input = parts.join('-')
      } else {
        input = value?.sortCode
      }
    }
    // Validate
    const validSortCode = RegExp(/^(\d{2}-\d{2}-\d{2})$/).test(input)
    const updatedValid = { ...valid, ...{ sortCode: validSortCode } }
    const validBankDetails = Object.values(updatedValid).every(Boolean)
    setValid(updatedValid)
    onChange({ ...value, ...{ sortCode: input, valid: validBankDetails } })
  }

  return (
    <>
      <Field
        key={`field-accountName`}
        id={`accountName`}
        className="bank-details__input"
        name={`accountName`}
        label={`Account Name *`}
        type={'text'}
        value={value?.accountName}
        placeholder="Mr John Smith"
        onChange={handleAccountName}
        fullWidth
        msg={valid.accountName === null ? null : valid.accountName ? '' : 'Please enter a valid account name'}
        state={valid.accountName === null ? null : valid.accountName ? 'Success' : 'Error'}
      />
      <Field
        key={`field-accountNo`}
        id={`accountNo`}
        className="bank-details__input"
        name={`accountNo`}
        label={`Account No. *`}
        type={'text'}
        value={value?.accountNo}
        placeholder="00000000"
        onChange={handleAccountNo}
        fullWidth
        msg={valid.accountNo === null ? null : valid.accountNo ? '' : 'Please enter a valid 8 digit account no.'}
        state={valid.accountNo === null ? null : valid.accountNo ? 'Success' : 'Error'}
      />
      <Field
        key={`field-sortCode`}
        id={`sortCode`}
        className="details__input bank-details__sort"
        name={`sortCode`}
        label={`Sort Code *`}
        type={'text'}
        value={value?.sortCode}
        placeholder="00-00-00"
        onChange={handleSortCode}
        fullWidth
        msg={valid.sortCode === null ? null : valid.sortCode ? '' : 'Please enter a valid sort code. e.g. 11-22-33'}
        state={valid.sortCode === null ? null : valid.sortCode ? 'Success' : 'Error'}
      />
    </>
  )
}

export default GBInputs
